export const BRANCHES = [
  'Portland',
  'Seattle', 
  'Anchorage',
  'Tri-Cities'
];

export const DEPARTMENTS = [
  'Service',
  'Testing',
  'Construction',
  'Electricians'
];

export const TIER_LEVELS = [1, 2, 3];

export const TIER_PAY_RATES = {
  1: 25,
  2: 30,
  3: 35
};

export const BRANCH_DEPARTMENTS = {
  'Portland': ['Service', 'Testing', 'Construction', 'Electricians'],
  'Seattle': ['Service', 'Testing', 'Construction', 'Electricians'],
  'Anchorage': ['Service', 'Testing', 'Construction'],
  'Tri-Cities': ['Service', 'Testing', 'Construction']
};

export const EMAIL_INTERVALS = {
  FIRST_WARNING: 60,  // days
  SECOND_WARNING: 30, // days
  FINAL_WARNING: 10,  // days
  EXPIRED: 0
};

export const ORGANIZATION = {
  BRANCHES,
  DEPARTMENTS,
  TIER_LEVELS,
  TIER_PAY_RATES,
  BRANCH_DEPARTMENTS,
  EMAIL_INTERVALS
};

export default ORGANIZATION;
